export enum ProcessInfoConclusion {
  InProgress = 'in-progress',
  Successful = 'successful',
  Failure = 'failure'
}
